import TagBadge from "../components/TagBadge";
import FileThumb from "../components/FileThumb";
import TagFilter from "../components/TagFilter";
import { COLORS, API } from "../constants";

export default function SearchView({ query, results, searched, selectedResults, toggleSelectResult, handleBulkDownload, handleBulkDelete, activeTagFilter, setActiveTagFilter, token, activeFolderId, folders }) {
  const filteredResults = results.filter(r => !activeTagFilter || r.tag === activeTagFilter);
  const allResultTags = [...new Set(results.map(r => r.tag).filter(Boolean))];

  if (!searched) return (
    <div style={{ textAlign: "center", padding: "60px 20px", color: COLORS.textTertiary }}>
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" style={{ marginBottom: "12px", opacity: 0.4 }}><circle cx="18" cy="18" r="13" stroke="currentColor" strokeWidth="2" /><path d="M28 28L36 36" stroke="currentColor" strokeWidth="2" strokeLinecap="round" /></svg>
      <p style={{ fontSize: "15px", color: COLORS.textSecondary, marginBottom: "6px" }}>Search your course materials</p>
      <p style={{ fontSize: "13px" }}>Type in the search bar above and press Enter</p>
    </div>
  );

  if (results.length === 0) return (
    <div style={{ textAlign: "center", padding: "60px 20px" }}>
      <p style={{ fontSize: "15px", color: COLORS.textSecondary }}>No results for "{query}"</p>
    </div>
  );

  return (
    <div>
      {selectedResults.length > 0 && (
        <div style={{ display: "flex", alignItems: "center", gap: "10px", padding: "8px 14px", background: COLORS.blueLight, border: `0.5px solid ${COLORS.blueMid}`, borderRadius: "8px", marginBottom: "10px" }}>
          <span style={{ fontSize: "13px", color: COLORS.blue, flex: 1 }}>{selectedResults.length} selected</span>
          <button onClick={() => handleBulkDownload(results.filter(r => selectedResults.includes(r.id)))} style={{ padding: "4px 12px", fontSize: "12px", background: "white", border: `0.5px solid ${COLORS.border}`, borderRadius: "6px", color: COLORS.textSecondary, cursor: "pointer" }}>Download</button>
          <button onClick={() => handleBulkDelete(selectedResults, true)} style={{ padding: "4px 12px", fontSize: "12px", background: COLORS.dangerBg, border: `0.5px solid ${COLORS.dangerBorder}`, borderRadius: "6px", color: COLORS.danger, cursor: "pointer" }}>Delete</button>
        </div>
      )}
      <div style={{ marginBottom: "10px" }}>
        <span style={{ fontSize: "12px", color: COLORS.textTertiary }}>
                {results.length} result{results.length !== 1 ? "s" : ""} for "{query}"
                {activeFolderId && folders && (() => {
                  const findFolder = (list, id) => { for (const f of list) { if (f.id === id) return f; if (f.children?.length) { const found = findFolder(f.children, id); if (found) return found; } } return null; };
                  const folder = findFolder(folders, activeFolderId);
                  return folder ? <span style={{ color: COLORS.blue }}> · in {folder.name}</span> : null;
                })()}
              </span>
      </div>
      <TagFilter tags={allResultTags} active={activeTagFilter} onSelect={setActiveTagFilter} />
      <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
        {filteredResults.map(r => (
          <div key={r.id} style={{ display: "flex", alignItems: "stretch", background: COLORS.bg, border: `0.5px solid ${selectedResults.includes(r.id) ? COLORS.blue : COLORS.border}`, borderRadius: "10px", overflow: "hidden" }}>
            <div style={{ width: "3px", background: r.matchType === "exact" ? COLORS.blue : "#9FE1CB", flexShrink: 0 }} />
            <div style={{ display: "flex", alignItems: "center", gap: "10px", flex: 1, padding: "10px 14px", minWidth: 0 }}>
              <input type="checkbox" checked={selectedResults.includes(r.id)} onChange={() => toggleSelectResult(r.id)} style={{ cursor: "pointer", flexShrink: 0 }} />
              <FileThumb filename={r.filename} />
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: "13px", fontWeight: "500", color: COLORS.textPrimary, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", marginBottom: "3px" }}>{r.filename}</div>
                {r.snippet && <div style={{ fontSize: "12px", color: COLORS.textSecondary, overflow: "hidden", display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", wordBreak: "break-word" }}>{r.snippet}</div>}
              </div>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "8px", padding: "10px 14px", borderLeft: `0.5px solid ${COLORS.borderLight}`, flexShrink: 0 }}>
              {r.tag && <TagBadge tag={r.tag} />}
              <span style={{ fontSize: "11px", color: r.matchType === "exact" ? "#27500A" : "#534AB7" }}>{r.matchType === "exact" ? "● Exact" : "○ Related"}</span>
              <span style={{ fontSize: "11px", color: COLORS.textTertiary }}>{new Date(r.uploaded_at).toLocaleDateString()}</span>
              <button onClick={() => window.open(`${API}/files/${r.id}/download?token=${token}`)} style={{ padding: "4px 12px", fontSize: "12px", background: "transparent", border: `0.5px solid ${COLORS.border}`, borderRadius: "6px", color: COLORS.textSecondary, cursor: "pointer" }}>Download</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}